import PropTypes from 'prop-types';
import React from 'react';
import { Box, Icon } from '@honda-canada/design-system-react';

import themeStyles from './Loader.styles';
import { SimpleStyle } from '../propTypes';

const AnimatedLoader = themeStyles.apply(Icon, 'AnimatedLoader');
const Container = themeStyles.apply(Box, 'Container');

const Loader = ({
  horizontalAlignment,
  loaderStyles,
  containerStyles,
  testId = 'loading-state',
  isLargeIcon = false,
  loadingIconHeight = 'undefined',
}) => (
  <Container horizontalAlignment={horizontalAlignment} {...containerStyles}>
    <AnimatedLoader
      data-testid={testId}
      name={isLargeIcon ? 'arrowXLargeRightCircleAnimated' : 'animatedLoader'}
      {...loaderStyles?.styles}
      isLargeIcon={isLargeIcon}
      loadingIconHeight={loadingIconHeight}
    />
  </Container>
);

Loader.propTypes = {
  horizontalAlignment: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  loaderStyles: PropTypes.shape({
    styles: SimpleStyle,
  }),
  containerStyles: SimpleStyle,
  isLargeIcon: PropTypes.bool,
};

export default Loader;
